<template>
  <pl-dialog 
    v-if="userInformation !== {}" 
    class="text-sm" title="Nudge" 
    size="confirm_size" 
    :disableOutsideClick="true" 
    @close="$emit('closeDialog', false)"
  >
    <div class="flex flex-col space-y-4 h-full px-6 py-5">
      <div class="flex items-center space-x-2">
        <i class="fa-solid fa-message text-emerald-600"></i>
        <div>
          <span>Send a Message to</span>
          <span class="font-semibold"> {{ userInformation.user.name }}</span>
        </div>
        
      </div>
      <div class="h-full flex-grow">
        <textarea rows="6" class="w-full outline-none border border-solid border-gray-200 bg-gray-50 resize-none rounded px-5 py-3" placeholder="Nudge! Have something to say?" v-model="message" />
      </div>
      <div class="flex items-center space-x-2 justify-between">
        <button @click="$emit('closeDialog', false)" class="w-full bg-gray-100 border border-solid border-gray-200 px-6 py-2 rounded-md">
          Cancel
        </button>
        <button @click="sendNudge" class="w-full bg-green hover:bg-emerald-600 px-6 py-2 rounded-md text-white">
          Send Message
        </button>
      </div>
    </div>

  </pl-dialog>
  <!-- <pl-dialog v-if="userInformation !== {}" class="text-sm" title="Nudge" size="confirm_size" :disableOutsideClick="true" @close="$emit('closeDialog', false)">
    <div class="px-7 py-7 flex-grow overflow-y-auto mb-12">
      <div class="flex justify-center items-center">
        <i class="fa-solid fa-message text-3xl text-green-600"></i>
      </div>
      <h6 class="text-gray-700 text-center text-base mb-3">
        Send Message to
        <span class="font-semibold"> {{ userInformation.user.name }}</span>
      </h6>
      <div class="mx-12 mb-2">
        <textarea rows="8" class="w-full outline-none bg-gray-100 rounded px-5 py-3" placeholder="Nudge! Have something to say?" v-model="message" />
      </div>
    </div>
    <div class="bg-white py-5 text-blueGray-800 bottom-0 absolute w-full">
      <div class="flex justify-center items-center">
        <button @click="$emit('closeDialog', false)" class="bg-gray-300 hover:bg-gray-400 px-6 py-2 rounded mr-3">
          Cancel
        </button>
        <button @click="sendNudge" class="bg-green-600 hover:bg-green-700 px-6 py-2 rounded text-white">
          Send Message
        </button>
      </div>
    </div>
  </pl-dialog> -->
</template>
<script>
  import Vue from 'vue';
  import { EventBus } from '../../../../utils/event-bus';
  export default Vue.extend({
    data() {
      return {
        message: '',
      };
    },
    props: {
      userInformation: { type: Object, default: {} },
    },
    methods: {
      sendNudge: function () {
        this.$store
          .dispatch('nudgeStudent', {
            participation_id: this.userInformation.id,
            message: this.message,
          })
          .then(() => {
            const toast = {
              type: 'Success',
              message:
                'Nudge sent successfully to ' + this.userInformation.user.name,
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            this.$emit('closeDialog', false);
          });
      },
    },
  });
</script>



// WEBPACK FOOTER //
// SendNudge.vue?e343dc50